import { tw } from '@/utils/tw';

const Instagram = tw.theme({
  base: ['w-full', 'min-h-[497px]', 'sm:min-h-[573px]', 'md:min-h-[696px]'],
});

export default Instagram;
